import React from 'react';
import UserSignupForm from './components/UserSignupForm';
import { useForm } from 'react-hook-form';
import Button from '../../components/ui/Button';
import { useNavigate } from 'react-router';
import { useAuth } from '../../contexts/authContext';
import { toast } from 'sonner';

function SignupPage() {
  let navigate = useNavigate();
  let { register: registerForm, handleSubmit, setError, formState: { errors, isSubmitting } } = useForm();
  const { register } = useAuth();

  let onSubmit = async (data) => {
    try {
      const response = await register(data);
      console.log('Registration successful:', response);
      
      // raise alert
      toast.success('Registration successful');

      // redirect to login page
      navigate('/complete-profile/role-selection');
    } catch (error) {
      console.error('Registration failed:', error);
      Object.keys(error).forEach((field) => {
        if (field === 'non_field_errors') {
            setGlobalError(error[field][0]);
        } else if (field === 'user') {
          Object.keys(error.user).forEach((userField) => {
            setError(userField, { type: 'server', message: error.user[userField][0] });
          })
        } else {
            setError(field, { type: 'server', message: error[field][0] });
        }
      });
    }
  }

  return (
    <div className='bg-base-200 py-12 px-4 sm:px-6 lg:px-8'>
      <div className='max-w-2xl mx-auto'>
        {/* <SignupToggle /> */}
        <h1 className="text-3xl text-center font-bold mb-8">Create Your Account</h1>
        <div className="bg-base-100 shadow-xl rounded-box p-8">
          <form onSubmit={handleSubmit(onSubmit)}>
            <UserSignupForm
              register={registerForm}
              errors={errors}
            />
            <Button
              className='w-full mt-4'
              isLoading={isSubmitting}
            >
              Create Account
            </Button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default SignupPage;